import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ToastOptions } from '../types';

interface State {
    toasts: ToastOptions[];
}

const initialState: State = {
    toasts: []
};

const toastsSlice = createSlice({
    name: 'toasts',
    initialState,
    reducers: {
        showToast: (state, { payload }: PayloadAction<{ toast: ToastOptions }>) => {
            const { toast } = payload;

            state.toasts.unshift(toast);
        },
        hideToast: (state, { payload }: PayloadAction<{ toastId: string }>) => {
            const { toastId } = payload;

            state.toasts = state.toasts.filter((toast) => toast.id !== toastId);
        }
    }
});

export const {
    hideToast,
    showToast
} = toastsSlice.actions;

export default toastsSlice.reducer;
